import { createSlice } from "@reduxjs/toolkit";

const initialCurriculumsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  curriculumForEdit: undefined,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const curriculumsSlice = createSlice({
  name: "curriculums",
  initialState: initialCurriculumsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCurriculumById
    curriculumFetched: (state, action) => {
      state.actionsLoading = false;
      state.curriculumForEdit = action.payload.curriculumForEdit;
      state.error = null;
    },
    // findCurriculums
    curriculumsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createCurriculum
    curriculumCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.curriculum);
    },
    // updateCurriculum
    curriculumUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.curriculum.id) {
          return action.payload.curriculum;
        }
        return entity;
      });
    },
    // deleteCurriculum
    curriculumDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    // deleteCurriculums
    curriculumsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => !action.payload.ids.includes(el.id)
      );
    },
    // curriculumsUpdateState
    curriculumsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
  },
});
